import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall,
  getBranches,
  getCustomers,
  getEmployes,
  getStatus,
  getTypes
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import {
  setCustomerReviews
} from "../../actions";

import CustomerServicesReportTable from "../../components/Tables/CustomerServicesReportTable";
import CustomerReviewBarChart from "../../components/Charts/CustomerReviewBarChart";
import Select from "react-select";
import './CustomerReports.css';
class CustomerReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerServiceData: [],
      customerReviewsData: [],
      branches: [],
      customers: [],
      status: [],
      employes: [],
      totals: [],
      type: [],
      selectedCustomer: [],
      formData: {
        startDateTime: '',
        endDateTime: '',
        by_customer: '',
        by_branch: '',
        by_employee: '',
        by_service_type: '',
        by_service_status: '',
      },
      loading: false,
      isLoad: true,

    }
  }
  componentDidMount() {
    this.getReports();
  }
  getReports = async () => {

    try {
      const response = await apiCall('business/reports/customer', 'post', null);
      const branches = await getBranches();
      const employes = await getEmployes();
      const types = await getTypes();
      const status = await getStatus();
      const customers = await getCustomers();

      this.setState({
        customerServiceData: response.customerServices,
        totals: response.totals,
        branches, employes, types, status, customers
      }, () => {
        this.props.setCustomerReviews(response.customerReviews);
        this.setState({ isLoad: false });
      });

    }
    catch (e) {
      this.setState({ isLoad: false });
      console.log(e);
    }
  }

  handleChange = (e) => {
    const { id, value } = e.target;
    const formData = { ...this.state.formData };
    formData[id] = value;
    this.setState({ formData });
  };
  handleCustomerChange = (selectedCustomer) => {
    const formattedSelectedOptions = {
      value: selectedCustomer.value,
      label: selectedCustomer.label,
    };
    this.setState((prevState) => ({

      formData: {
        ...prevState.formData,
        by_customer: formattedSelectedOptions.value
      },
      selectedCustomer: formattedSelectedOptions
    }));

  };
  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ loading: true });
    const { formData } = this.state;
    const reportFormData = new FormData();
    Object.keys(formData).forEach(key => {
      reportFormData.append(key, formData[key]);
    });
    try {
      const response = await apiCall('business/reports/customer', 'post', reportFormData);
      this.setState({
        customerServiceData: response.customerServices,
        totals: response.totals,
      });
      this.props.setCustomerReviews(response.customerReviews);
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  render() {
    const {
      customerServiceData,
      formData,
      loading,
      isLoad,
      branches,
      employes,
      types,
      status,
      customers,
      totals,
      selectedCustomer
    } = this.state;
    const customerFormattedOptions = customers
      .filter(option => option.is_supplier === 0)
      .map(option => ({
        value: option.id,
        label: option.name + ' ' + (option.surname || "")
      }));
    const { userPermissions } = this.props;
    const userHasUpdateBusinessInfoPermission = userPermissions.includes('update business');

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Raporlar"
              Breadcrumb={[
                { name: "Raporlar", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <form onSubmit={this.handleSubmit}>
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="start_date" className="font-weight-bold text-cyan">
                              Başlangıç Tarihi
                            </label>
                            <input
                              id="start_date"
                              className="form-control"
                              type="datetime-local"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="end_date" className="font-weight-bold text-cyan">
                              Bitiş Tarihi
                            </label>
                            <input
                              id="end_date"
                              className="form-control"
                              type="datetime-local"
                              value={formData.endDateTime}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_branch" className="font-weight-bold text-cyan">
                              Şube
                            </label>
                            <select name="by_branch" id="by_branch" className="form-control"
                              onChange={this.handleChange}>
                              <option value="">Seçiniz</option>
                              {branches && branches.map((branch) => (
                                <option key={branch.id} value={branch.id}>
                                  {branch.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_customer" className="font-weight-bold text-cyan">
                              Müşteri
                            </label>
                            <Select
                              id="customer"
                              placeholder="Müşteri Seçiniz..."
                              options={customerFormattedOptions}
                              value={selectedCustomer}
                              onChange={this.handleCustomerChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_service_status" className="font-weight-bold text-cyan">
                              Servis Durumu
                            </label>
                            <select name="by_service_status" id="by_service_status" className="form-control"
                              onChange={this.handleChange}>
                              <option value="">Seçiniz</option>
                              {status && status.map((statu) => (
                                <option key={statu.id} value={statu.id}>
                                  {statu.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_service_type" className="font-weight-bold text-cyan">
                              Servis Tipi
                            </label>
                            <select name="by_service_type" id="by_service_type" className="form-control"
                              onChange={this.handleChange}>
                              <option value="">Seçiniz</option>
                              {types && types.map((type) => (
                                <option key={type.id} value={type.id}>
                                  {type.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label htmlFor="by_employee" className="font-weight-bold text-cyan">
                              Çalışan
                            </label>
                            <select name="by_employee" id="by_employee" className="form-control"
                              onChange={this.handleChange}>
                              <option value="">Seçiniz</option>
                              {employes && employes.map((employee) => (
                                <option key={employee.id} value={employee.id}>
                                  {employee.name + ' ' + employee.surname}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="body">
                      <div className="col-lg-12 d-flex justify-content-center">
                        <div className="col-lg-4">
                          <div className="form-group">
                            {loading ? (
                              <button className="btn btn-outline-primary btn-sm btn-block" disabled={true}
                                style={{ textAlign: "-webkit-center" }}>
                                Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                  color="#268bd2"></ReactLoading>
                              </button>
                            ) :
                              <button disabled={!userHasUpdateBusinessInfoPermission}
                                className="btn btn-outline-primary btn-sm btn-block"
                                type="submit">
                                Güncelle
                              </button>}
                          </div>
                        </div>
                      </div>

                    </div>
                  </form>

                  {/* Modern Customer Statistics Cards */}
                  <div className="body modern-customer-stats-section">
                    <div className="row clearfix">
                      {/* Total Customers Card */}
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="modern-customer-stat-card card-blue">
                          <div className="stat-icon-wrapper">
                            <i className="fa fa-users" style={{ fontSize: '3rem', color: '#3498db' }}></i>
                          </div>
                          <div className="stat-content">
                            <h3 className="stat-title">Toplam Müşteri</h3>
                            <div className="stat-value">{totals.totalCustomer || 0}</div>
                            <p className="stat-subtitle">Tüm müşteriler</p>
                          </div>
                        </div>
                      </div>

                      {/* Customers with Service Card */}
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="modern-customer-stat-card card-orange">
                          <div className="stat-icon-wrapper">
                            <i className="fa fa-wrench" style={{ fontSize: '3rem', color: '#f39c12' }}></i>
                          </div>
                          <div className="stat-content">
                            <h3 className="stat-title">Servis Kaydı Olan</h3>
                            <div className="stat-value">{totals.hasService || 0}</div>
                            <p className="stat-subtitle">
                              {totals.totalCustomer > 0
                                ? `%${Math.round((totals.hasService / totals.totalCustomer) * 100)} müşteri`
                                : 'Müşteri yok'}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Just Customers Card */}
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="modern-customer-stat-card card-green">
                          <div className="stat-icon-wrapper">
                            <i className="fa fa-user" style={{ fontSize: '3rem', color: '#27ae60' }}></i>
                          </div>
                          <div className="stat-content">
                            <h3 className="stat-title">Sadece Müşteri</h3>
                            <div className="stat-value">{totals.justCustomer || 0}</div>
                            <p className="stat-subtitle">
                              {totals.totalCustomer > 0
                                ? `%${Math.round((totals.justCustomer / totals.totalCustomer) * 100)} müşteri`
                                : 'Müşteri yok'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="body">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="card">
                          <div className="header">
                            <h2>Müşteri Değerlendirme Raporu</h2>
                          </div>
                          {!isLoad ? (
                            this.props.customerReviewsData.length > 0 ?
                              <CustomerReviewBarChart></CustomerReviewBarChart>
                              : (
                                <div className="body">
                                  <div className="alert alert-warning">
                                    Veri yok
                                  </div>
                                </div>
                              )
                          ) : ""}

                        </div>
                      </div>
                      <div className="col-lg-12 d-flex">
                        <div className="card">
                          <div className="header">
                            <h2>Müşteri Servis Geçmişi</h2>
                          </div>
                          <CustomerServicesReportTable
                            bodyData={customerServiceData}
                          />
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ analyticalReducer }) => ({
  customerReviewsData: analyticalReducer.customerReviewsData
});

export default withPermissions(withRouter(connect(mapStateToProps, { setCustomerReviews })(CustomerReport)));
